module.exports = __webpack_public_path__ + "img/Equatorial Guinea.5da2ae04.svg";